import React from 'react';
import imgPayNowIcon from './assets/img_pagar_ahora.png';

const ProcessingPaymentIcon = () => {
  return <img src={imgPayNowIcon.src} width="241" height="279" alt="" />;
};

export default ProcessingPaymentIcon;
